import { render, staticRenderFns } from "./copyFormList.vue?vue&type=template&id=2cf067db&scoped=true&"
import script from "./copyFormList.vue?vue&type=script&lang=js&"
export * from "./copyFormList.vue?vue&type=script&lang=js&"
import style0 from "./copyFormList.vue?vue&type=style&index=0&id=2cf067db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf067db",
  null
  
)

export default component.exports